module.exports = __webpack_public_path__ + "img/pro3.f00d0146.svg";